
export const MicrotaskBulckUpload = (data) => {
    var formdata = new FormData()
    console.log(data);

    if(data.attachments){
        formdata.append('attachments',data.attachments.rawFile)
    }

    if(data.type){
        formdata.append('status',data.type)
    }

    return formdata;
}